export default (data) => {
  const base = {
    state: false,
    data: data.data ? data.data.result : null,
    success: !!data.success,
    loading: false,
  };
  return base;
};
